import React, { useState } from "react";
import { useGlobal } from "reactn";
import { useHistory } from "react-router-dom";

import AuthRedirect from "components/Accounts/Auth/AuthRedirect";

import SettingsHeader from "./SettingsHeader";
import SettingsNav from "./SettingsNav";
import SettingsRouter from "./SettingsRouter";

import { useQuery } from "@apollo/client";
import { GET_USER_SETTINGS } from "@ugg/shared/api/graphql/queries";
import { GET_USER_STATE } from "@ugg/shared/api/requests/accounts/user-state";

const Settings = () => {
  const history = useHistory();
  const [authToken] = useGlobal("authToken");
  const [loggingIn] = useGlobal("loggingIn");
  const [currentPage, setPage] = useState();
  const [redirectingProvider, setRedirectingProvider] = useState(null);

  const {
    loading: loadingUserState,
    data: userState,
    error: errorUserState,
  } = useQuery(GET_USER_STATE, { fetchPolicy: "network-only", skip: !authToken });

  const {
    loading: loadingUserSettings,
    data: userSettings,
    error: errorUserSettings,
  } = useQuery(GET_USER_SETTINGS, { fetchPolicy: "network-only", skip: !userState || !authToken });

  if (!authToken) {
    history.replace("/");
    return null;
  }

  if (errorUserState || errorUserSettings) {
    return null;
  }

  if (loggingIn || loadingUserState || loadingUserSettings) {
    return (
      <div className="settings-page settings_loading">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      {redirectingProvider && (
        <AuthRedirect siteName={redirectingProvider.charAt(0).toUpperCase() + redirectingProvider.slice(1)} />
      )}
      <div className="settings-page content-side-padding">
        <SettingsHeader page={currentPage} />
        <SettingsNav isBoost={userState?.getState?.premium?.hasLegacyBoost} />
        <SettingsRouter
          setPage={setPage}
          userState={userState?.getState}
          userSettings={userSettings?.getSettings}
          refetchQueries={[{ query: GET_USER_STATE }, { query: GET_USER_SETTINGS }]}
          setRedirectingProvider={setRedirectingProvider}
          premiumState={userState?.getState?.premium}
        />
      </div>
    </>
  );
};

export default Settings;
